import React, { useState, useEffect } from "react";
import { Form, DatePicker, Input } from "antd";
import dayjs from 'dayjs';
import { get } from 'lodash';

const DatePickerInput = ({
  values,
  errors,
  setFieldValue,
  setFieldTouched,
  name,
  label,
  formItemLayout,
  placeholder,
  readOnly,
  showTime,
  allowClear,
  disabledDate,
  defaultPickerValue,
  overrideformat,
}) => {
  const stored = get(values, name);
  const [localValue, setLocalValue] = useState(stored ? dayjs.utc(stored) : null);

  useEffect(() => {
    setLocalValue(stored ? dayjs.utc(stored) : null);
  }, [stored]);

  return (
    <Form.Item label={label} {...formItemLayout}
      hasFeedback={!!get(errors, name)}
      validateStatus={get(errors, name) && "error"}
      help={get(errors, name)}
    >
      {!readOnly &&
        <DatePicker
          defaultPickerValue={defaultPickerValue ? defaultPickerValue : undefined}
          disabledDate={disabledDate}
          placeholder={placeholder}
          value={localValue}
          onChange={date => {
            setLocalValue(date);
            setFieldValue(name, date ? date.utc(true).toISOString() : null);
          }}
          onBlur={() => setFieldTouched(name)}
          disabled={readOnly}
          format={overrideformat ? overrideformat : showTime ? 'DD-MM-YYYY HH:mm:ss' : 'DD-MM-YYYY'}
          allowClear={allowClear ? allowClear : false}
          showTime={showTime}
        />
      }
      {readOnly &&
        <Input
          placeholder={placeholder}
          value={stored ? dayjs(stored).format('DD-MM-YYYY') : ' '}
          readOnly={readOnly}
        />
      }
    </Form.Item>
  );
};

export default DatePickerInput;
